import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Button, Spinner, Form } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { getHydrantListById, saveHydrantData, updateHydrantData } from "../../redux/actions/HydrantActions";
import FormInput from "../../Components/FormInput";
import { useNavigate, useParams } from "react-router-dom";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import swal from 'sweetalert2';
import LeafletSingleMap from "../../Components/LeafletSingleMap";
import { getAddressByLatLng, getAllUsertypeUserList, getMasterUsertypeUserWiseList,getAllUsersRoleWiseList } from "../../redux/actions/MasterActions";
import { getDestinationListById, saveDestinationData, updateDestinationData } from "../../redux/actions/DestinationActions";
import Preloader from "../../Components/Preloader";

const Add = () => {
  const { id } = useParams();
  const navigate = useNavigate();
    const [roleCode,setroleCode]=useState("JUNIOR_ENGINEER");
  
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    latitude: 0.00,
    longitude: 0.00
  });
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    destinationReducer: {
      loadingDestination,
      errorsDestination,
      destinationLists,
      changedDestinationStatus,
    },
    masterReducer: {
      reverseAddressList,
      masterUsertypeUserLists,
      masterUsersRoleWiseLists,
    }
  } = useSelector((state) => state);


  const [validated, setValidated] = useState(false);
      const [fieldErrors, setFieldErrors] = useState({});
  

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    if (id) {
       const updatedpayload={ id: id,
          "name": formData?.name,
          "latitude": Number(formData?.latitude),
          "longitude": Number(formData?.longitude),
          "address": formData?.address,
          "jenId": formData?.jenId,
          "status":formData?.status,
      }
      dispatch(updateDestinationData(auth?.accessToken, updatedpayload, id));
    }
    else {
      const payload={
          "name": formData?.name,
          "latitude": Number(formData?.latitude),
          "longitude": Number(formData?.longitude),
          "address": formData?.address,
          "jenId": formData?.jenId,
          "status":formData?.status,
      }
      dispatch(saveDestinationData(auth?.accessToken, payload));
    }
  };

  useEffect(() => {
    //setFormData({});
    //dispatch({ type: 'RESET_DELETE_DESTINATION_STATUS' });
  }, [dispatch]);


  useEffect(() => {
    // dispatch(getAllUsertypeUserList(auth?.accessToken, 13, ''));
    if (id) {
      dispatch(getDestinationListById(auth?.accessToken, id));
    }
  }, [auth, id]);


 useEffect(() => {
    if (auth?.accessToken && roleCode) {
      dispatch(getAllUsersRoleWiseList(auth?.accessToken, roleCode));
    }
  }, [auth?.accessToken, roleCode, dispatch]);

  useEffect(() => {
    if (id) {
      if (destinationLists && Object.keys(destinationLists).length > 0) {
        setFormData({
          "name": destinationLists?.name,
          "latitude": destinationLists?.latitude,
          "longitude": destinationLists?.longitude,
          "address": destinationLists?.address,
          "jenId": destinationLists?.jen?.id,
          "status":destinationLists?.status,

        });
      }
    }

  }, [destinationLists])

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      if (errors?.status === 401) {
        dispatch(logout());
        toast.error(errors?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }
  }, [errors, dispatch, navigate]);

  useEffect(() => {
    if (errorsDestination && Object.keys(errorsDestination).length > 0) {
      if (errorsDestination?.status === 409) {
        swal.fire({
          show: true,
          title: "Oops!",
          text: errorsDestination?.data?.message,
          icon: "error",
          showConfirmButton: false,
          timer: 1500
        });
        dispatch({ type: 'RESET_DELETE_DESTINATION_STATUS' });
      }
      else if (errorsDestination?.status === 400) {
        if (errorsDestination?.data?.errors && Array.isArray(errorsDestination.data.errors)) {
          const transformedErrors = {};
          errorsDestination.data.errors.forEach(error => {
            if (error.field && error.message) {
              transformedErrors[error.field] = error.message;
            }
          });
          setFieldErrors(transformedErrors);
        }
      }
      else {
        dispatch({ type: 'RESET_DELETE_DESTINATION_STATUS' });
      }
    }
  }, [errorsDestination, dispatch]);

  useEffect(() => {
    if (changedDestinationStatus?.message) {
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedDestinationStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_DESTINATION_STATUS' });
      navigate(-1);
    }
  }, [changedDestinationStatus, dispatch, navigate]);

  useEffect(() => {
    setFormData({});
    dispatch({ type: 'RESET_DELETE_HYDRANT_STATUS' });
  }, [dispatch]);

  const inputHandler = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
     if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const inputHandlerCaps = (e) => {
    const { value, name } = e.target;
    const processedValue = value.replace(/\s+/g, '').toUpperCase(); // Remove spaces and convert to uppercase
    setFormData({ ...formData, [name]: processedValue });
     if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const selectHandler = (selectedData, name) => {
    console.log("selectedData", selectedData, name);
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedData
    }));
     if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors?.data?.state_code ? 'red' : base.borderColor,
      '&:hover': {
        borderColor: errors?.data?.state_code ? 'red' : base.borderColor,
      }
    }),
  };

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log(position);
          setFormData({ ...formData, latitude: position.coords.latitude, longitude: position.coords.longitude });
        },
        (error) => {
          //setError(error.message);
        }
      );
    } else {
      //setError('Geolocation is not supported by this browser.');
    }
  }, []);


    useEffect(() => { 
      console.log('fieldErrors', fieldErrors);
    },[fieldErrors]);

  useEffect(() => {
    setFormData({ ...formData, address: reverseAddressList?.label });
  }, [reverseAddressList])

useEffect(() => {
    setFieldErrors({});
},[(navigate)]);

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("Destination"), path: "Destination" },
          { label: id ? t("Update Destination") : t("Add Destination"), path: "/Add-Destination", active: true },
        ]}
        title={id ? t("Update Destination") : t("Add Destination")}
      />
      <Row>
        <Col lg={6}>
          <Card>
            <Card.Body>
              <div style={{ position: "relative", overflow: "hidden", height: "400px" }}>
                <LeafletSingleMap
                  mapHeight={"600px"}
                  center={[formData.latitude || 0.00, formData.longitude || 0.00]}
                  zoom={15}
                  setFormData={setFormData}
                />
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={6}>
          <Card>
            <Card.Body>
              {errorsDestination?.data?.message && (
                <div className="alert alert-danger">
                  {errorsDestination?.data?.message}
                </div>
              )}

              <Row>
                <Col lg={12}>
                  <FormInput
                    label={t("Name")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.name}
                    name="name"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={6}>
                  <FormInput
                    label={t("Latitude")}
                    type="nmber"
                    errors={fieldErrors}
                    value={formData?.latitude}
                    name="latitude"
                    onChange={inputHandlerCaps}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={6}>
                  <FormInput
                    label={t("Longitude")}
                    type="text"
                    errors={fieldErrors}
                    value={formData?.longitude}
                    name="longitude"
                    onChange={inputHandlerCaps}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={12}>
                  <FormInput
                    label={t("Address")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.address}
                    name="address"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("J.E.N.")}</Form.Label>
                    <Select
                     className={fieldErrors?.jenId ? "border-danger" : ""}
                      options={masterUsersRoleWiseLists}
                      values={masterUsersRoleWiseLists?.filter(state => state?.id === formData.jenId)}
                      name="jenId"
                      labelField={"name"}
                      valueField={"id"}
                      searchBy={"name"}
                      onChange={(selectedData) => selectHandler(selectedData[0]?.id, "jenId")}
                      styles={customSelectStyles}
                    />
                    {fieldErrors?.jenId && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.jenId}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              <div className="d-flex justify-content-center">
                {loadingDestination ?
                  <Button color="primary" disabled>
                    <Spinner
                      className="spinner-border-sm me-1"
                      tag="span"
                      color="white"
                    />
                    Please wait ...
                  </Button>
                  :
                  <Button type="button" onClick={handleSubmit} disabled={loadingDestination}>
                    Submit
                  </Button>
                }
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {loadingDestination && (<Preloader />)}

    </>
  );
};

export default Add;
